"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _chartUtils = require("../../chartUtils");

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

var _colors = require("../../constants/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HoverBody = function HoverBody(_ref) {
  var coordinateCrosshairValues = _ref.coordinateCrosshairValues,
      hasBattery = _ref.hasBattery,
      timeZone = _ref.timeZone;
  var charge = coordinateCrosshairValues.charge,
      consumption = coordinateCrosshairValues.consumption,
      contract = coordinateCrosshairValues.contract,
      discharge = coordinateCrosshairValues.discharge,
      estimatedSolar = coordinateCrosshairValues.estimatedSolar,
      exportValue = coordinateCrosshairValues.exportValue,
      importValue = coordinateCrosshairValues.importValue,
      maxBattery = coordinateCrosshairValues.maxBattery,
      minBattery = coordinateCrosshairValues.minBattery,
      peer = coordinateCrosshairValues.peer,
      peerV2 = coordinateCrosshairValues.peerV2,
      selfConsumption = coordinateCrosshairValues.selfConsumption,
      solar = coordinateCrosshairValues.solar,
      systemProduction = coordinateCrosshairValues.systemProduction,
      x = coordinateCrosshairValues.x;
  var contractedPercentDiff = (0, _chartUtils.getFulfillmentPercentDiff)(solar, contract);
  var peerPercentDiff = (0, _chartUtils.getFulfillmentPercentDiff)(solar, peer);
  var peerV2PercentDiff = (0, _chartUtils.getFulfillmentPercentDiff)(solar, peerV2);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.CrosshairDate, {
    dateMillis: x,
    timeZone: timeZone
  }), !(0, _lodash.isNil)(solar) && (0, _lodash.isNil)(estimatedSolar) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverAreaKey, {
    stroke: _colors.SOLAR,
    fill: _colors.SOLAR_OPAQUE
  }, "Solar ".concat((0, _chartUtils.getFormattedValue)(solar, 3), " kWh")), !(0, _lodash.isNil)(estimatedSolar) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverAreaKey, {
    stroke: _colors.SOLAR,
    fill: _colors.ESTIMATED_SOLAR_HOVER
  }, "Estimated Solar ".concat((0, _chartUtils.getFormattedValue)(estimatedSolar, 3), " kWh")), hasBattery && !(0, _lodash.isNil)(systemProduction) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.SYSTEM_PRODUCTION,
    strokeDasharray: 4
  }, "System Production: ".concat((0, _chartUtils.getFormattedValue)(systemProduction, 3), " kWh")), !(0, _lodash.isNil)(peerV2) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.PEER_V2
  }, "Peer: ".concat((0, _chartUtils.getFormattedValue)(peerV2, 3), " kWh"), peerV2PercentDiff && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLegendPercent, null, " (".concat(peerV2PercentDiff, "%)"))), !(0, _lodash.isNil)(peer) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.PEER_ADJ
  }, "Legacy Peer: ".concat((0, _chartUtils.getFormattedValue)(peer, 3), " kWh"), peerPercentDiff && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLegendPercent, null, " (".concat(peerPercentDiff, "%)"))), !(0, _lodash.isNil)(contract) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.CONTRACTED
  }, "Contracted: ".concat((0, _chartUtils.getFormattedValue)(contract, 3), " kWh"), contractedPercentDiff && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLegendPercent, null, " (".concat(contractedPercentDiff, "%)"))), !(0, _lodash.isNil)(consumption) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.CONSUMPTION
  }, "Total Usage: ".concat((0, _chartUtils.getFormattedValue)(consumption, 3), " kWh")), !(0, _lodash.isNil)(selfConsumption) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverAreaKey, {
    fill: _colors.SELF_CONSUMPTION,
    stroke: _colors.SELF_CONSUMPTION
  }, "Self-Generated Usage: ".concat((0, _chartUtils.getFormattedValue)(selfConsumption, 3), " kWh")), hasBattery && !(0, _lodash.isNil)(charge) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverAreaKey, {
    fill: _colors.BATTERY_CHARGED
  }, "Battery Charged: ".concat((0, _chartUtils.getFormattedValue)(charge, 3), " kWh")), hasBattery && !(0, _lodash.isNil)(discharge) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverAreaKey, {
    fill: _colors.BATTERY_DISCHARGED
  }, "Battery Discharged: ".concat((0, _chartUtils.getFormattedValue)(discharge, 3), " kWh")), !(0, _lodash.isNil)(exportValue) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverAreaKey, {
    fill: _colors.EXPORT,
    stroke: _colors.EXPORT
  }, "Export: ".concat((0, _chartUtils.getFormattedValue)(exportValue, 3), " kWh")), !(0, _lodash.isNil)(importValue) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverAreaKey, {
    fill: _colors.IMPORT_COLOR,
    stroke: _colors.IMPORT_COLOR
  }, "Import: ".concat((0, _chartUtils.getFormattedValue)(importValue, 3), " kWh")), hasBattery && !(0, _lodash.isNil)(maxBattery) && !(0, _lodash.isNil)(minBattery) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.DARK_GREEN
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginRight: '5px'
    }
  }, "Max Percentage:"), /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.BatteryPercentage, {
    batteryPercentage: maxBattery
  }, " ".concat((0, _chartUtils.getFormattedValue)(maxBattery, 1), "%"))), /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.DARK_GREEN
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginRight: '5px'
    }
  }, "Min Percentage:"), /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.BatteryPercentage, {
    batteryPercentage: minBattery
  }, " ".concat((0, _chartUtils.getFormattedValue)(minBattery, 1), "%")))));
};

HoverBody.propTypes = {
  coordinateCrosshairValues: _propTypes["default"].shape({
    charge: _propTypes["default"].number,
    consumption: _propTypes["default"].number,
    contract: _propTypes["default"].number,
    discharge: _propTypes["default"].number,
    estimatedSolar: _propTypes["default"].number,
    exportValue: _propTypes["default"].number,
    importValue: _propTypes["default"].number,
    maxBattery: _propTypes["default"].number,
    minBattery: _propTypes["default"].number,
    peer: _propTypes["default"].number,
    peerV2: _propTypes["default"].number,
    selfConsumption: _propTypes["default"].number,
    solar: _propTypes["default"].number,
    systemProduction: _propTypes["default"].number,
    x: _propTypes["default"].number
  }).isRequired,
  hasBattery: _propTypes["default"].bool.isRequired,
  timeZone: _propTypes["default"].string.isRequired
};
var _default = HoverBody;
exports["default"] = _default;